import TextArea from 'antd/es/input/TextArea';
import { QuestionType } from 'common/enum';
import { useEffect, useState } from 'react';

type Props = {
  commitChange: (dataChange: any, rightAnswer: string | number | undefined | null, questionType: QuestionType) => void;
  rightAnswer: string | number | undefined | null;
};

export default function EditShortQuestion({ rightAnswer, commitChange }: Props) {
  const [rightAnswerEdit, setRightAnswer] = useState<string | number | undefined | null>(rightAnswer);

  const onChangeInput = function (e: any) {
    commitChange(null, e.target.value, QuestionType.SHORT_QUESTION);
  };

  useEffect(() => {
    setRightAnswer(rightAnswer);
  }, [rightAnswer]);

  return (
    <TextArea
      placeholder="Nhập đáp án"
      name="rightAnswer"
      className="flex-1 h-[10%] "
      value={rightAnswerEdit ? rightAnswerEdit : ''}
      style={{ height: 60, resize: 'none' }}
      maxLength={255}
      onChange={(e) => onChangeInput(e)}
    />
  );
}
